<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="80px" label-position="left">
    <el-form-item label="定价模式">
      <el-radio-group v-model="form.pricingModel" @change="modelChange" :disabled="id">
        <el-radio label="1">单位定价</el-radio>
        <el-radio label="2">阶梯定价</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-row>
      <el-col span="1"></el-col>
      <el-col span="23">
        <el-form-item label="仪表大类" style="display：flex;">
          <el-row gutter="10">
            <el-col span="6">
              <el-select
                v-model="form.meterBig"
                placeholder="请选择"
                style="width: 100%"
                :disabled="id"
              >
                <el-option
                  v-for="(item, index) in dicts.fee_standard_meter_big"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-col>
            <el-col span="4" style="text-align: right">仪表小类</el-col>
            <el-col span="6">
              <el-select
                v-model="form.meterSmall"
                placeholder="请选择"
                style="width: 100%"
                :disabled="id"
              >
                <el-option
                  v-for="(item, index) in dicts.fee_standard_meter_small"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <!-- 单位定价 -->
        <el-form-item label="算费费率" v-if="form.pricingModel == 1" prop="feePrice">
          <el-row gutter="10">
            <el-col span="6">
              <el-input
                type="text"
                v-model="form.feePrice"
                style="width: 100%"
                :disabled="id"
                maxlength="10"
                :show-word-limit="true"
              ></el-input>
            </el-col>
            <el-col span="2"> 元 / </el-col>
            <el-col span="6">
              <el-select v-model="form.feeUnit" style="width: 100%" :disabled="id">
                <template v-for="item in dicts.fee_standard_unit">
                  <el-option
                    v-if="item.dictKey[0] == fee_standard_unit_first_number"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </template>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <!-- 阶梯定价 -->
        <div v-if="form.pricingModel == 2">
          <div style="display: flex; justify-content: flex-start">
            <div style="width: 108px">用量区间</div>
            <div>
              <el-row gutter="10" v-for="(item, index) in form.priceRange" :key="index">
                <el-col span="3">
                  <el-form-item
                    label-width="0"
                    :prop="'priceRange.' + index + '.startLevel'"
                    :rules="listRules.startLevel"
                  >
                    <el-input
                      type="number"
                      v-model="item.startLevel"
                      style="width: 100%"
                      :disabled="id"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="1" style="text-align: center">至</el-col>
                <el-col span="3">
                  <el-form-item
                    label-width="0"
                    :prop="'priceRange.' + index + '.endLevel'"
                    :rules="listRules.endLevel"
                  >
                    <el-input
                      type="number"
                      v-model="item.endLevel"
                      style="width: 100%"
                      :disabled="id"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="2" style="text-align: center">费率</el-col>
                <el-col span="3">
                  <el-form-item
                    label-width="0"
                    :prop="'priceRange.' + index + '.amount'"
                    :rules="listRules.amount"
                  >
                    <el-input
                      type="number"
                      v-model="item.amount"
                      style="width: 100%"
                      :disabled="id"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="2" style="text-align: center">元 /</el-col>
                <el-col span="3">
                  <el-select
                    v-model="form.feeUnit"
                    style="width: 100%"
                    :disabled="id"
                  >
                    <template v-for="item in dicts.fee_standard_unit">
                      <el-option
                        v-if="item.dictKey[0] == fee_standard_unit_first_number"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                      ></el-option>
                    </template>
                  </el-select>
                </el-col>
                <el-col span="2" style="text-align: center">
                  <i
                    v-if="index == 0 && !id"
                    class="el-icon-circle-plus"
                    style="color: #409eff; font-size: 30px"
                    @click="addItem"
                  ></i>
                  <i
                    v-if="index > 0 && !id"
                    class="el-icon-remove"
                    style="color: #409eff; font-size: 30px"
                    @click="delItem(index)"
                  ></i>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { validation } from '@/util/validation';
export default {
  props: {
    form: Object,
    dicts: Object,
    id: String,
  },
  data() {
    return {
      fee_standard_unit_first_number: '3',
      rules: {
        feePrice: [
          { required: true, message: '请输入费率', trigger: 'change' },
          {
            validator: (rule, value, cb) => {
              value = value + '';
              console.log('value==>', value);
              if (!/^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/.test(value)) {
                cb(new Error('金额格式错误'));
              } else {
                cb();
              }
            },
            message: '格式错误',
            trigger: 'change',
          },
        ],
        pricingModel:[{ required: true, message: '请选择', trigger: 'change' }],
      },
      listRules: {
        startLevel: [{ required: true, validator: validation.vMoney(), trigger: 'blur' }],
        endLevel: [{ required: true, validator: validation.vMoney(), trigger: 'blur' }],
        amount: [{ required: true, validator: validation.vMoney(), trigger: 'blur' }],
      },

    };
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    modelChange(val) {
      console.log('val==>', val);
    },
    addItem() {
      this.form.priceRange.push({ startLevel: '', endLevel: '', amount: '', unit: '' });
    },
    delItem(index) {
      this.form.priceRange.splice(index, 1);
    },
    validate() {
      return new Promise((resolve, rej) => {
        this.$refs.form
          .validate()
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    save() {
      // if xxx 判断
      console.log('this.checkEmptyForPriceRange==>', this.checkEmptyForPriceRange());
      if (!this.checkEmptyForPriceRange()) {
        this.$message({
          message: '缴费区间存在空值或者单位',
          type: 'warning',
        });
        return;
      }
      console.log(
        'this.checkOverlapAndContinuityForPriceRange==>',
        this.checkOverlapAndContinuityForPriceRange()
      );
      if (!this.checkOverlapAndContinuityForPriceRange()) {
        this.$message({
          message: '缴费区间存在重叠区或者不连续',
          type: 'warning',
        });
        return;
      }
    },
    checkOverlapAndContinuityForPriceRange() {
      let starts = [];
      let ends = [];
      let res = false;
      this.form.priceRange.forEach((item) => {
        starts.push(item.startLevel);
        ends.push(item.endLevel);
      });
      starts = starts.sort();
      ends = ends.sort();
      if (starts.length != ends.length) {
        res = false;
      }
      for (let i = 1; i < starts.length; i++) {
        if (starts[i] == ends[i - 1]) {
        } else {
          res = false;
          break;
        }
      }
      return res;
    },
    checkEmptyForPriceRange() {
      let temp = true;
      this.form.priceRange.forEach((item) => {
        if (!(item.startLevel && item.endLevel && item.amount && item.unit)) {
          temp = false;
        }
      });
      return temp;
    },
    test(e) {
      console.log('1==>', 1);
      this.$refs.form.validate((v) => {
        console.log('v==>', v);
      });
      return false;
    },
    setInitValue() {
      if (this.dicts) {
        //不足月计算方式
        this.form.lessMonthDaysWay =
          this.dicts.fee_standard_less_month_days_way &&
          this.dicts.fee_standard_less_month_days_way.length &&
          this.dicts.fee_standard_less_month_days_way[0].dictKey;
        this.form.lessMonthWay =
          this.dicts.fee_standard_less_month_way &&
          this.dicts.fee_standard_less_month_way.length &&
          this.dicts.fee_standard_less_month_way[0].dictKey;
        this.form.meterBig =
          (this.dicts.fee_standard_meter_big &&
            this.dicts.fee_standard_meter_big.length &&
            this.dicts.fee_standard_meter_big[0].dictKey) ||
          '';
        this.form.meterSmall =
          (this.dicts.fee_standard_meter_big_small &&
            this.dicts.fee_standard_meter_big_small.length &&
            this.dicts.fee_standard_meter_big_small[0].dictKey) ||
          '';
        console.log('this.form.meterSmall==>', this.form.meterSmall);
        console.log('this.form.meterBig==>', this.form.meterBig);
        //算费费率单位
        if (this.dicts.fee_standard_unit) {
          for (let i = 0; i < this.dicts.fee_standard_unit.length; i++) {
            let item = this.dicts.fee_standard_unit[i];
            if (item.dictKey[0] == this.fee_standard_unit_first_number) {
              this.form.feeUnit = item.dictKey;
              break;
            }
          }
        }
      }
    },
  },
  created() {
    this.setInitValue();
  },
};
</script>